export const AppColors = {
  black: {
    blackAlpha100: "rgba(0,0,0,1)",
    blackAlpha090: "rgba(0,0,0,0.9)",
    blackAlpha080: "rgba(0,0,0,0.8)",
    blackAlpha070: "rgba(0,0,0,0.7)",
    blackAlpha060: "rgba(0,0,0,0.6)",
    blackAlpha050: "rgba(0,0,0,0.5)",
  },
  blue: {
    persianBlue: "rgb(63, 55, 201)"
  }
};
